import idx from "idx"

import { formatDate, formatSlug } from "@jsUtils"
import { getSafeDataMap } from "@jsUtils/contentful"

/**
 * transform - manipulate data for thought leadership stories
 * @param {object} news - news query
 * @returns {object}
 */
function transform(news) {
  const stories = getSafeDataMap(news, story => {
    const rawDate = idx(story, _ => _.date)
    const rawSlug = idx(story, _ => _.slug)
    const rawCategory = idx(story, _ => _.category)
    const slug = `/${formatSlug(rawCategory)}/${rawSlug}`
    return {
      id: idx(story, _ => _.id),
      title: idx(story, _ => _.title),
      slug,
      date: formatDate(rawDate),
      thumbnail: idx(story, _ => _.thumbnail)
    }
  })
  return {
    stories
  }
}

export default { transform }
